/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function logList (params) {
  return api({
    method: 'post',
    url: '/appLog/list/' + params.appId,
    data: params
  })
}
